import getSelectedTableView from './getSelectedTableView';
import { owaComputedFn } from 'owa-computed-fn';

const getComputedIsInVirtualSelectAllMode = owaComputedFn(
    function getComputedIsInVirtualSelectAllMode(): boolean {
        return getSelectedTableView()?.isInVirtualSelectAllMode ?? false;
    }
);
export default getComputedIsInVirtualSelectAllMode;
